var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticStyle:{"height":"100%"},attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","xl":"10"}},[_c('login')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }